import { UseQueryResult } from "@tanstack/react-query"
import { getFactoryDataById, getFactoryDataNonAuthen } from "services/factory"
import { ResponseGetFactoryById, ResponseGetFactoryDataNonAuthen } from "services/interface"
import { useQuery } from "@tanstack/react-query"


export const useGetFactoryDataById = (
    factoryId: string
  ): UseQueryResult<ResponseGetFactoryById, Error> => {
    return useQuery<ResponseGetFactoryById, Error>({
        queryKey: ['factory_data_by_id', factoryId],
        queryFn: () => getFactoryDataById(factoryId),
        staleTime: 1000 * 60 * 60 * 1,
    })
  }

  export const useGetFactoryDataNonAuthen = (): UseQueryResult<ResponseGetFactoryDataNonAuthen, Error> => {
    return useQuery<ResponseGetFactoryDataNonAuthen, Error>({
        queryKey: ['factory_data_nonauthen'],
        queryFn: () => getFactoryDataNonAuthen(),
    })
  }
